module.exports = __webpack_public_path__ + "img/voguepay_static.c14496e2.svg";